export default "__VITE_ASSET__77012239__"